(function (window, document) {
  'use strict';

  var root = document.querySelector('[data-cookie-consent]');
  var settings = document.querySelector('[data-cookie-settings]');
  if (!root || !settings || window.BDConsent) return;

  var storageKey = 'bd_cookie_consent_v2';
  var legacyKey = 'bd_cookie_consent_v1';
  var status = root.querySelector('[data-cookie-status]');
  var accept = root.querySelector('[data-cookie-accept]');
  var essential = root.querySelector('[data-cookie-essential]');
  var customize = root.querySelector('[data-cookie-customize]');
  var details = root.querySelector('[data-cookie-details]');
  var saveCustom = root.querySelector('[data-cookie-save]');
  var purposeInputs = Array.prototype.slice.call(root.querySelectorAll('[data-cookie-purpose]'));
  var previousFocus = null;
  var loading = null;
  var confirmedByShopify = false;
  var choice = null;

  function safeParse(value) {
    if (!value) return null;
    try {
      var parsed = JSON.parse(value);
      if (parsed && typeof parsed === 'object') return parsed;
    } catch (_) {}
    if (value === 'all') return { analytics: true, marketing: true, preferences: true };
    if (value === 'essential') return { analytics: false, marketing: false, preferences: false };
    return null;
  }

  function readSaved() {
    try {
      return safeParse(window.localStorage.getItem(storageKey)) || safeParse(window.localStorage.getItem(legacyKey));
    } catch (_) {
      return null;
    }
  }

  function save(value) {
    try {
      window.localStorage.setItem(storageKey, JSON.stringify(value));
      window.localStorage.removeItem(legacyKey);
    } catch (_) {}
  }

  function privacyApi() {
    return window.Shopify && window.Shopify.customerPrivacy;
  }

  function currentConsent() {
    try {
      var api = privacyApi();
      return api && typeof api.currentVisitorConsent === 'function' ? api.currentVisitorConsent() : null;
    } catch (_) {
      return null;
    }
  }

  function matches(value, consent) {
    if (!value || !consent) return false;
    return consent.analytics === (value.analytics ? 'yes' : 'no') &&
      consent.marketing === (value.marketing ? 'yes' : 'no') &&
      consent.preferences === (value.preferences ? 'yes' : 'no');
  }

  function analyticsAllowed() {
    try {
      var api = privacyApi();
      return Boolean(
        choice &&
        choice.analytics === true &&
        confirmedByShopify &&
        matches(choice, currentConsent()) &&
        api &&
        typeof api.analyticsProcessingAllowed === 'function' &&
        api.analyticsProcessingAllowed() === true
      );
    } catch (_) {
      return false;
    }
  }

  function notify() {
    document.dispatchEvent(new CustomEvent('bd:consent-changed', {
      detail: {
        choice: choice,
        confirmed: confirmedByShopify,
        analyticsAllowed: analyticsAllowed()
      }
    }));
  }

  window.BDConsent = { analyticsAllowed: analyticsAllowed };

  function syncInputs(value) {
    purposeInputs.forEach(function (input) {
      input.checked = Boolean(value && value[input.dataset.cookiePurpose]);
    });
  }

  function showDetails(open) {
    if (!details || !customize) return;
    details.hidden = !open;
    customize.setAttribute('aria-expanded', String(open));
    if (open) {
      syncInputs(choice || readSaved() || { analytics: false, marketing: false, preferences: false });
      var first = details.querySelector('input,button');
      if (first) first.focus();
    }
  }

  function open(focus) {
    if (root.hidden) previousFocus = document.activeElement;
    root.hidden = false;
    root.setAttribute('aria-hidden', 'false');
    settings.hidden = true;
    settings.setAttribute('aria-expanded', 'true');
    showDetails(false);
    if (focus && accept) accept.focus();
  }

  function close(restoreFocus) {
    root.hidden = true;
    root.setAttribute('aria-hidden', 'true');
    root.removeAttribute('aria-busy');
    settings.hidden = false;
    settings.setAttribute('aria-expanded', 'false');
    showDetails(false);
    if (status) status.textContent = '';
    if (restoreFocus) {
      var target = previousFocus && document.contains(previousFocus) && previousFocus !== document.body ? previousFocus : settings;
      if (target && typeof target.focus === 'function') target.focus();
    }
  }

  function ready() {
    var api = privacyApi();
    if (api && typeof api.setTrackingConsent === 'function' && typeof api.currentVisitorConsent === 'function') return Promise.resolve(api);
    if (loading) return loading;

    loading = new Promise(function (resolve, reject) {
      var settled = false;
      var timer = window.setTimeout(function () { finish(new Error('privacy-api-timeout')); }, 6000);
      function finish(err) {
        if (settled) return;
        settled = true;
        window.clearTimeout(timer);
        var loaded = privacyApi();
        if (err || !loaded || typeof loaded.setTrackingConsent !== 'function' || typeof loaded.currentVisitorConsent !== 'function') reject(err || new Error('privacy-api-unavailable'));
        else resolve(loaded);
      }
      try {
        if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') finish(new Error('privacy-loader-unavailable'));
        else window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], finish);
      } catch (err) {
        finish(err);
      }
    });

    loading.catch(function () { loading = null; });
    return loading;
  }

  function apply(value, restoreFocus) {
    choice = {
      analytics: Boolean(value.analytics),
      marketing: Boolean(value.marketing),
      preferences: Boolean(value.preferences)
    };
    confirmedByShopify = false;
    save(choice);

    // Navigation must never depend on Shopify's privacy API.
    close(restoreFocus);
    notify();

    ready().then(function (api) {
      try {
        api.setTrackingConsent({
          analytics: choice.analytics,
          marketing: choice.marketing,
          preferences: choice.preferences
        }, function (err) {
          if (err) {
            confirmedByShopify = false;
            notify();
            return;
          }
          confirmedByShopify = matches(choice, currentConsent());
          notify();
        });
      } catch (_) {
        confirmedByShopify = false;
        notify();
      }
    }).catch(function () {
      // Fail safe: optional tracking remains unavailable; browsing remains usable.
      confirmedByShopify = false;
      notify();
    });
  }

  if (accept) accept.addEventListener('click', function () {
    apply({ analytics: true, marketing: true, preferences: true }, true);
  });

  if (essential) essential.addEventListener('click', function () {
    apply({ analytics: false, marketing: false, preferences: false }, true);
  });

  if (customize) customize.addEventListener('click', function () {
    showDetails(details ? details.hidden : true);
  });

  if (saveCustom) saveCustom.addEventListener('click', function () {
    var selected = { analytics: false, marketing: false, preferences: false };
    purposeInputs.forEach(function (input) {
      selected[input.dataset.cookiePurpose] = input.checked;
    });
    apply(selected, true);
  });

  settings.addEventListener('click', function () {
    choice = readSaved();
    syncInputs(choice);
    open(true);
  });

  document.addEventListener('keydown', function (event) {
    if (root.hidden) return;

    if (event.key === 'Escape' && readSaved()) {
      event.preventDefault();
      close(true);
      return;
    }

    if (event.key !== 'Tab') return;
    var focusable = Array.prototype.slice.call(root.querySelectorAll('button:not([disabled]),a[href],input:not([disabled])')).filter(function (el) {
      return !el.closest('[hidden]');
    });
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (!root.contains(document.activeElement) || (!event.shiftKey && document.activeElement === last)) {
      event.preventDefault();
      first.focus();
    } else if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    }
  });

  document.addEventListener('focusin', function (event) {
    if (!root.hidden && root.getAttribute('aria-hidden') !== 'true' && !root.contains(event.target) && accept) accept.focus();
  });

  document.addEventListener('visitorConsentCollected', function () {
    if (choice) confirmedByShopify = matches(choice, currentConsent());
    notify();
  });

  window.addEventListener('storage', function (event) {
    if (event.key !== storageKey && event.key !== legacyKey) return;
    choice = readSaved();
    if (!choice) open(false);
    else {
      close(false);
      confirmedByShopify = matches(choice, currentConsent());
      notify();
    }
  });

  choice = readSaved();
  if (!choice) {
    open(false);
  } else {
    close(false);
    syncInputs(choice);
    ready().then(function () {
      confirmedByShopify = matches(choice, currentConsent());
      notify();
      if (!confirmedByShopify) {
        // Best-effort sync with Shopify without blocking the page.
        apply(choice, false);
      }
    }).catch(function () {
      confirmedByShopify = false;
      notify();
    });
  }
})(window, document);

(function (window, document) {
  'use strict';
  var html = document.documentElement;
  if (html.dataset.bd99MeasurementBridge === '1') return;
  html.dataset.bd99MeasurementBridge = '1';
  var pending = [];
  var currentScript = document.currentScript || document.querySelector('script[src*="consent-controller.js"]');

  function emit(name, detail) {
    var payload = detail || {};
    if (window.AIONMeasurement && typeof window.AIONMeasurement.emit === 'function') {
      window.AIONMeasurement.emit(name, payload);
    } else {
      pending.push([name, payload]);
    }
  }

  function flush() {
    if (!window.AIONMeasurement || typeof window.AIONMeasurement.emit !== 'function') return;
    var queued = pending.slice();
    pending.length = 0;
    queued.forEach(function (item) { window.AIONMeasurement.emit(item[0], item[1]); });
  }

  function tagOrientationLinks(scope) {
    var base = scope && scope.querySelectorAll ? scope : document;
    base.querySelectorAll('a[href]').forEach(function (link) {
      var href = String(link.getAttribute('href') || '');
      if (href.indexOf('bildungs-kompass') !== -1) {
        link.setAttribute('data-aion-action', 'open_compass');
        link.setAttribute('data-aion-stage', 'orientation');
      } else if (href.indexOf('deutsch-sprachcheck-kostenlos') !== -1 || href.indexOf('thema=Sprachcheck') !== -1) {
        link.setAttribute('data-aion-action', 'open_language_check');
        link.setAttribute('data-aion-stage', 'orientation');
      } else if (href.indexOf('thema=Bildungsberatung') !== -1) {
        link.setAttribute('data-aion-action', 'open_consultation');
        link.setAttribute('data-aion-stage', 'orientation');
      }
    });
  }

  if (currentScript && currentScript.src && !html.dataset.bd99MeasurementLoader) {
    html.dataset.bd99MeasurementLoader = 'loading';
    var script = document.createElement('script');
    script.src = currentScript.src.replace(/consent-controller\.js(?:\?.*)?$/, 'b2b-analytics.js?v=1.4.2');
    script.defer = true;
    script.onload = function () {
      html.dataset.bd99MeasurementLoader = 'ready';
      flush();
    };
    script.onerror = function () {
      html.dataset.bd99MeasurementLoader = 'error';
      pending.length = 0;
    };
    document.head.appendChild(script);
  }

  tagOrientationLinks(document);
  document.addEventListener('shopify:section:load', function (event) { tagOrientationLinks(event.target); });

  document.addEventListener('click', function (event) {
    var target = event.target.closest && event.target.closest('[data-compass-next],[data-reset-compass]');
    if (!target) return;
    var compass = target.closest('[data-shopify-compass]');
    if (!compass) return;
    if (target.matches('[data-reset-compass]')) {
      emit('compass_reset', { journey_stage: 'orientation' });
      compass.removeAttribute('data-bd99-compass-started');
      return;
    }
    var form = compass.querySelector('[data-compass-form]');
    var steps = form ? Array.prototype.slice.call(form.querySelectorAll('[data-compass-step]')) : [];
    if (!steps.length) return;
    var index = Number(compass.dataset.compassIndex || 0);
    if (!Number.isFinite(index) || index < 0 || index >= steps.length) return;
    if (!steps[index].querySelector('input:checked')) return;
    if (!compass.hasAttribute('data-bd99-compass-started')) {
      compass.setAttribute('data-bd99-compass-started', '1');
      emit('compass_start', { journey_stage: 'orientation', steps_total: steps.length });
    }
    if (index === steps.length - 1) {
      emit('compass_complete', { journey_stage: 'consideration', steps_total: steps.length });
    }
  }, true);
})(window, document);
